module.exports = __webpack_public_path__ + "img/tzyy.fa3bfd61.png";